module.exports = __webpack_public_path__ + "static/media/nominate-ambassador.9c5adec9.jpg";